<template>
  <b-card class="chat-message">
    <span class="time">{{message.time_stamp | getMomentStr}}</span><br>
    <span class="text-danger">Unknown message type {{messageType}}.</span>
  </b-card>
</template>

<script>
export default {
  name: 'MessageUnknown',

  props: {
    messageType: {
      type: Number,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    }
  },
};
</script>
